module.exports = __webpack_public_path__ + "9761f58793b45afc0fdb63f6fbdd42fe.fbx";